import { add } from 'lodash';
// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

(function ($) {
    const OlySLider = {
        sliders: [],
        containers: [],
        attr: 'data-cs',
        mainSliderObj: {},
        getMainSlider: (_) => {
            return OlySLider.mainSliderObj;
        },
        bindTinySlider: (_) => {
            Array.from(OlySLider.containers).forEach((container) => {
                const defaultOptions = { container: container };
                const dataOptions = JSON.parse(container.getAttribute(OlySLider.attr).replace(/'/g, '"'));
                const funcOptions = {
                    onInit: (_) => OlySLider.bindOnInitFunctions(container, dataOptions),
                };
                const options = Object.assign(defaultOptions, dataOptions, funcOptions);
                const slider = tns(options);
                const olySliderObj = { id: container.id, slider: slider };
                OlySLider.sliders.push(olySliderObj);
                if (container.id === 'mainSlider') {
                    OlySLider.mainSliderObj = olySliderObj;
                    OlySLider.bindOlyNav(container, options);
                }
            });
        },
        bindOnInitFunctions: (container, options) => {
            OlySLider.bindAutoHeightListener(container, options);
        },
        checkEnabledAutoHeight: (options) => {
            return options.olyAutoHeight;
        },
        checkEnabledNav: (options) => {
            return options.olyNav;
        },
        checkEnabledCounter: (options) => {
            return options.olyCounter;
        },
        checkNavTypeClass: (options) => {
            return (
                options.navTypeClass !== 'undefined' &&
                options.navTypeClass !== undefined &&
                typeof options.navTypeClass === 'string'
            );
        },
        getNavTypeClass: (options) => {
            return options.navTypeClass;
        },
        getNavType: (options) => {
            //TODO:add functionality for types. For now it will be true either with or without
            if (OlySLider.checkEnabledNav(options)) {
                if (options.olyNavType === 'circle' || options.olyNavType === 'rectangle' || true) {
                    return options.olyNavType;
                } else {
                    console.error('The Nav type should be either circle or rectangle');
                    return false;
                }
            }
        },
        minTwoDigits: (n) => {
            return (n < 10 ? '0' : '') + n;
        },
        calculateMaxHeight: (selector) => {
            const items = document.querySelectorAll(selector);
            let maxHeight = 0;
            Array.from(items).forEach((item) => {
                maxHeight = item.clientHeight < maxHeight ? maxHeight : item.clientHeight;
            });
            Array.from(items).forEach((element, data) => {
                element.style.height = maxHeight + 'px';
            });
        },
        bindOlyNav: (container, options) => {
            if (OlySLider.getNavType(options)) {
                $('#mainSlider-ow .tns-nav').wrap(function () {
                    return (
                        "<div class='slider-counter-wrapper'>" +
                        '<div class="slider-counter container">\n' +
                        '                    <div id="main-counter">\n' +
                        '                    </div>\n' +
                        '                    </div>\n' +
                        '</div>'
                    );
                });

                if (OlySLider.checkEnabledCounter(options)) OlySLider.bindOlyCounter();

                if (OlySLider.checkNavTypeClass(options))
                    document.querySelector('.slider-counter-wrapper').classList.add(OlySLider.getNavTypeClass(options));
            }
        },
        bindOlyCounter: (_) => {
            const totalCount = OlySLider.mainSliderObj.slider.getInfo().slideCount;
            $('#main-counter').append(
                '<div class="oly-counter">\n' +
                '                <span id="current-count">' +
                OlySLider.minTwoDigits(1) +
                '</span>\n' +
                '                <span id="total-count">' +
                OlySLider.minTwoDigits(totalCount) +
                '</span>\n' +
                '            </div>',
            );
            OlySLider.mainSliderObj.slider.events.on('indexChanged', (info, eventName) => {
                document.getElementById('current-count').innerHTML = OlySLider.minTwoDigits(info.displayIndex);
            });
        },
        bindAutoHeightListener: (container, options) => {
            if (OlySLider.checkEnabledAutoHeight(options)) {
                window.onload = (_) => OlySLider.calculateMaxHeight('#' + container.id + ' .slider-item');
                window.onresize = (_) => OlySLider.calculateMaxHeight('#' + container.id + ' .slider-item');
            }
        },
        initialize: (_) => {
            OlySLider.containers = document.querySelectorAll('[data-cs^="{"]');
            if (OlySLider.containers.length) {
                OlySLider.bindTinySlider();
            } else {
                // console.warn('OlySlider initialized but doesn\'t found any slider.')
            }
        },
    };
    OlySLider.initialize();
    // window.OlySlider = OlySLider.sliders; Uncomment if you would like to use
})(jQuery);

const projectIMGSlider = new Swiper('.project-img-slider', {
    slidesPerView: 1,
    speed: 1000,
    spaceBetween: 0,
    loop: false,
    breakpoints: {
        0: {
            slidesPerView: 1.01,
            centeredSlides: true,
            spaceBetween: 12,
        },
        600: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
    },
    freeMode: true,
    initialSlide: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});



const homeSlider = new Swiper('.home-slider', {
    slidesPerView: 1,
    speed: 2000,
    spaceBetween: 0,
    loop: false,
    centeredSlides: true,
    autoplay: {
        delay: 8000,
        disableOnInteraction: false,
    },
    allowTouchMove: false,
    watchSlidesVisibility: true,

    slidechange: function () {
        console.log('slide changed');
    },
    navigation: {
        nextEl: '.next-button',
        prevEl: '.prev-button',
    },
    on: {
        init: function () {
            $('.main-slider .home-project-swiper .text-field .wrapper .button-field .new-button').css('opacity', '1');
        },
        // slider active olduğunda opacity 1 yap değilse 0 yap
        slideChange: function () {
            $('.main-slider .home-project-swiper .text-field .wrapper .button-field .new-button').css('opacity', '1');
        },


    },
});
const homeprojectswip = new Swiper('.home-project-swiper', {
    slidesPerView: 1,
    speed: 2000,
    loopedSlides: 2,
    spaceBetween: 0,
    loop: false,
    centeredSlides: true,
    allowTouchMove: false,
    watchSlidesVisibility: true,

    effect: 'creative',
    creativeEffect: {
        limitProgress: 3,
        prev: {
            translate: [0, '-50%', 0],
            opacity: [0],
        },
        next: {
            translate: [0, '50%', 0],
            opacity: [0],
        },
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
    },
});
const homeprojectswipbtn = new Swiper('.home-project-button', {
    slidesPerView: 1,
    speed: 2000,
    loopedSlides: 2,
    spaceBetween: 0,
    loop: false,
    centeredSlides: true,
    allowTouchMove: false,
    watchSlidesVisibility: true,

    effect: 'creative',
    creativeEffect: {
        limitProgress: 3,
        prev: {
            translate: [0, 0, 0],
            opacity: [0],
            PointerEvents: 'none',
        },
        next: {
            translate: [0, 0, 0],
            opacity: [0],
            PointerEvents: 'none',
        },
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
    },

});
homeSlider.controller.control = homeprojectswip;
homeprojectswip.controller.control = homeSlider;

// homeprojectswip ile homeprojectswipbtn'i bağlama
homeprojectswip.controller.control = homeprojectswipbtn;
homeprojectswipbtn.controller.control = homeprojectswip;


var sliderText = $('.main-slider .home-slider .text-field .wrapper .text');
var sliderButton = $('.main-slider .button-field .new-button');
var slidernextButton = $('.main-slider .home-slider .text-field .wrapper .button-field .next-button');
var sliderprevButton = $('.main-slider .home-slider .text-field .wrapper .button-field .prev-button');
sliderText.html($('.swiper-slide-active').attr('data-text'));
sliderButton.attr('href', $('.swiper-slide-active').attr('data-project-url'));
homeSlider.on('slideChange', function () {
    sliderText.html($('.swiper-slide-active').attr('data-text'));
    sliderButton.attr('href', $('.swiper-slide-active').attr('data-project-url'));
    sliderText.addClass('active-text');
    sliderButton.removeClass('active');
    slidernextButton.removeClass('active');
    sliderprevButton.removeClass('active');
    setTimeout(() => {
        sliderButton.addClass('active');
        slidernextButton.addClass('active');
        sliderprevButton.addClass('active');
        sliderText.removeClass('active-text');
    }, 2000);
});
// home-slider varsa çalıştır
if ($('.home-slider').length) {
    $('.hamburger-menu').click(function () {
        // Tıklama işlemi sonrasında toggle işlemi yapın
        $(this).toggleClass('is-active');

        // Tıklama işlemi sonrasında otomatik oynatmayı güncelleyin
        if ($(this).hasClass('is-active')) {
            homeSlider.autoplay.stop();
        } else {
            homeSlider.autoplay.start();
        }
    });
}

if ($('main-slider')) {
    $(document).on('mousemove', function (e) {
        $('.slider-cursor').css({
            left: e.pageX - 160,
            top: e.pageY - 150,
        });
    });
}
